export const dividerHeights = {
  flush: 'var(--space-s)',
  xsmall: 'var(--space-m)',
  small: 'var(--space-l)',
  medium: 'var(--space-xl)',
  large: 'var(--space-2xl)',
  xlarge: 'var(--space-3xl)',
};
